import React from 'react';
import './GameIcon.css';

// Импортируем SVG иконки
import SlotMachineIcon from '../../assets/icons/slot-machine.svg';
import CoinFlipIcon from '../../assets/icons/coin-flip.svg';
import DiceIcon from '../../assets/icons/dice.svg';
import RacingFlagIcon from '../../assets/icons/racing-flag.svg';
import PickaxeIcon from '../../assets/icons/pickaxe.svg';

interface GameIconProps {
  gameId: string;
  className?: string;
}

const GameIcon: React.FC<GameIconProps> = ({ gameId, className = '' }) => {
  const iconPaths: { [key: string]: string } = {
    'lunar_lottery': SlotMachineIcon,
    'star_flip': CoinFlipIcon,
    'cosmic_dice': DiceIcon,
    'meteor_race': RacingFlagIcon,
    'asteroid_miner': PickaxeIcon
  };

  const iconPath = iconPaths[gameId] || SlotMachineIcon;

  return (
    <div className={`game-icon-container ${className}`}>
      <img src={iconPath} alt={gameId} />
    </div>
  );
};

export default GameIcon;
